// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotableConcepts_notable-concepts--scroll__Q4vUT {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  overflow-x: auto;
}
.NotableConcepts_notable-concepts--scroll__Q4vUT::-webkit-scrollbar-track {
  background-color: transparent;
}
.NotableConcepts_notable-concepts--scroll__Q4vUT::-webkit-scrollbar {
  height: 12px;
  background-color: transparent;
}
.NotableConcepts_notable-concepts--scroll__Q4vUT::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.3);
}
.NotableConcepts_notable-concepts__container__QC6xU {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media only screen and (max-width: 480px) {
  .NotableConcepts_notable-concepts__container__QC6xU {
    grid-template-columns: 1fr;
  }
}
.NotableConcepts_notable-concepts--group__izHwj {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.NotableConcepts_notable-concepts--item__56fo7 {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border: 1px solid var(--light-grey);
  border-radius: 8px;
  color: var(--dark-grey);
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
}
.NotableConcepts_notable-concepts--btn__Fbrts {
  position: sticky !important;
  left: 0;
  text-decoration: underline !important;
}
@media only screen and (max-width: 480px) {
  .NotableConcepts_notable-concepts--item__56fo7 {
    width: 100%;
    padding: 12px;
    font-size: 14px;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_ranking__wpuQV {
    font-size: 24px;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_concept-wrapper__cM5fh {
    justify-content: space-between;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_concept-wrapper__cM5fh .NotableConcepts_concept__uREfh {
    font-size: 16px;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_concept-link__wE-8f svg {
    width: 12px;
    height: 12px;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_statistics__6Qa-V .NotableConcepts_statistic__Le\\+-u svg {
    width: 12px;
    height: 12px;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_statistics__6Qa-V .NotableConcepts_statistic__label__sz56x {
    display: none;
  }
  .NotableConcepts_notable-concepts--item__56fo7 .NotableConcepts_statistics__6Qa-V .NotableConcepts_statistic__value__kMZNm {
    font-size: 14px;
  }
}

.NotableConcepts_top-keywords-modal__YDakr {
  height: 80vh;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .NotableConcepts_top-keywords-modal__YDakr {
    height: 100vh;
  }
}

.NotableConcepts_scrollable-body__d4UFw {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/NotableConcepts/NotableConcepts.module.scss"],"names":[],"mappings":"AACE;EACE,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,6BAAA;AAAN;AAGI;EACE,YAAA;EACA,6BAAA;AADN;AAII;EACE,mBAAA;EACA,oCAAA;AAFN;AAME;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAJJ;AAMI;EANF;IAOI,0BAAA;EAHJ;AACF;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAOE;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mCAAA;EACA,kBAAA;EACA,uBAAA;EAEA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AANJ;AASE;EACE,2BAAA;EACA,OAAA;EACA,qCAAA;AAPJ;AAUE;EACE;IACE,WAAA;IACA,aAAA;IACA,eAAA;EARJ;EAUI;IACE,eAAA;EARN;EAWI;IACE,8BAAA;EATN;EAWM;IACE,eAAA;EATR;EAcM;IACE,WAAA;IACA,YAAA;EAZR;EAkBQ;IACE,WAAA;IACA,YAAA;EAhBV;EAmBQ;IACE,aAAA;EAjBV;EAoBQ;IACE,eAAA;EAlBV;AACF;;AAyBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAtBF;AAwBE;EALF;IAMI,aAAA;EArBF;AACF;;AAwBA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AArBF","sourcesContent":[".notable-concepts {\n  &--scroll {\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    overflow-x: auto;\n\n    &::-webkit-scrollbar-track {\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar {\n      height: 12px;\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: 12px;\n      background-color: rgba($color: #000, $alpha: 0.3);\n    }\n  }\n\n  &__container {\n    padding: 12px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n\n    @media only screen and (max-width: 480px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &--group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &--item {\n    width: 100%;\n    background-color: #fff;\n    padding: 20px;\n    border: 1px solid var(--light-grey);\n    border-radius: 8px;\n    color: var(--dark-grey);\n    // box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 50%);\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    cursor: pointer;\n  }\n\n  &--btn {\n    position: sticky !important;\n    left: 0;\n    text-decoration: underline !important;\n  }\n\n  @media only screen and (max-width: 480px) {\n    &--item {\n      width: 100%;\n      padding: 12px;\n      font-size: 14px;\n\n      .ranking {\n        font-size: 24px;\n      }\n\n      .concept-wrapper {\n        justify-content: space-between;\n\n        .concept {\n          font-size: 16px;\n        }\n      }\n\n      .concept-link {\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n      }\n\n      .statistics {\n        .statistic {\n          svg {\n            width: 12px;\n            height: 12px;\n          }\n\n          &__label {\n            display: none;\n          }\n\n          &__value {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.top-keywords-modal {\n  height: 80vh; // fallback height for non-mobile\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 768px) {\n    height: 100vh;\n  }\n}\n\n.scrollable-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notable-concepts--scroll": `NotableConcepts_notable-concepts--scroll__Q4vUT`,
	"notable-concepts__container": `NotableConcepts_notable-concepts__container__QC6xU`,
	"notable-concepts--group": `NotableConcepts_notable-concepts--group__izHwj`,
	"notable-concepts--item": `NotableConcepts_notable-concepts--item__56fo7`,
	"notable-concepts--btn": `NotableConcepts_notable-concepts--btn__Fbrts`,
	"ranking": `NotableConcepts_ranking__wpuQV`,
	"concept-wrapper": `NotableConcepts_concept-wrapper__cM5fh`,
	"concept": `NotableConcepts_concept__uREfh`,
	"concept-link": `NotableConcepts_concept-link__wE-8f`,
	"statistics": `NotableConcepts_statistics__6Qa-V`,
	"statistic": `NotableConcepts_statistic__Le+-u`,
	"statistic__label": `NotableConcepts_statistic__label__sz56x`,
	"statistic__value": `NotableConcepts_statistic__value__kMZNm`,
	"top-keywords-modal": `NotableConcepts_top-keywords-modal__YDakr`,
	"scrollable-body": `NotableConcepts_scrollable-body__d4UFw`
};
export default ___CSS_LOADER_EXPORT___;
